<template>
  <div>
    <jade-alert
      showIcon
      variant="positive"
      :title="$t('title')"
    >
      {{ $t('description') }}
    </jade-alert>
  </div>
</template>

<script>
import { JadeAlert } from '@jade'
export default {
  name: 'SuccessAcquirerAffiliationAlert',

  components: {
    JadeAlert
  }
}
</script>

<i18n>
{
  "pt-BR": {
    "title": "Sucesso!",
    "description": "As alterações foram salvas com sucesso."
  },
  "en-US": {
    "title": "Success!",
    "description": "The changes have been successfully saved."
  }
}
</i18n>
